import { Box, Button, Checkbox, Stack, TFCard, TFText } from '@tf/ui';
import { fmt } from '@tf/utils';
import type { FunctionComponent } from 'react';
import { useState } from 'react';

import { useProfileConsentQuery } from '@/core/api/account';
import { useSelectedAccount } from '@/core/hooks';

const HideText: FunctionComponent<{ text: string }> = ({ text }) => {
	const [isHidden, setIsHidden] = useState(true);

	return (
		<Stack gap="0.25rem" align="start">
			{isHidden ? null : <TFText>{text}</TFText>}
			<Button variant="subtle" size="xs" onClick={() => setIsHidden(!isHidden)}>
				...
			</Button>
		</Stack>
	);
};

export const Consents: FunctionComponent = () => {
	const { profileId } = useSelectedAccount();

	const consentQuery = useProfileConsentQuery(profileId);

	return (
		<TFCard title="Consents">
			<Box py="0.75rem" px="1rem">
				{consentQuery.data ? (
					<Stack gap="1rem">
						<Box sx={{ display: 'flex', alignItems: 'top', gap: '0.5rem' }}>
							<Checkbox checked disabled />
							<Stack gap="0.25rem" sx={{ whiteSpace: 'pre-wrap', fontSize: '14px' }}>
								<TFText>{consentQuery.data.labels.label}</TFText>
								{consentQuery.data.data.description ? <HideText text={consentQuery.data.data.description} /> : null}
								<TFText>{fmt.toDate(consentQuery.data.meta.signed_at, { preset: 'full_date' })}</TFText>
							</Stack>
						</Box>
					</Stack>
				) : !consentQuery.isPending ? (
					<TFText c="dimmed">Consent not received via the Client-facing interface. Please check other sources.</TFText>
				) : null}
			</Box>
		</TFCard>
	);
};
